<template lang="pug">
  .content(v-if="action")
    div.is-fix
      div.fasi.columns
        div.column(v-for="(fase, key) in fasi" :key="key")
          div.fase(@click="setFase(key)" :class="status(key).value")
            span.icon-wrapper
              icon-base(width="30" height="30" :icon-name="key" :iconColor="status(key).color")
                component(:is="`Icon${key}`")
            p.title.is-7 {{ key }}
      h2.title.is-4
        icon-base(width="30" height="30" icon-name="line-chart" iconColor="#0567b3")
          icon-line-chart
        | Indicatori
        span.meta
          span(@click="changeDisplay('grid')")
            icon-base(width="20" height="18" icon-name="grid" :iconColor="display==='grid' ? '#dddddd' : '#0567b3'")
              icon-grid
          span(@click="changeDisplay('list')")
            icon-base(width="20" height="18" icon-name="list" :iconColor="display==='list' ? '#dddddd' : '#0567b3'")
              icon-list
          span(@click="changeDisplay('spider')")
            icon-base(width="20" height="20" icon-name="spider" :iconColor="display==='spider' ? '#dddddd' : '#0567b3'")
              icon-graphs
    section(class="indicator-list")
      ul
        li(v-for="(items, index) in configurator" :key="index" :class="{ 'active': index === selected }")
          h6(@click="select(index)" :style="{backgroundColor: items.colore, color: items.colore }")
            span.name {{ items.categoria }}
            span(v-if="items.item.length")
              span(v-if="index === selected" class="is-pulled-right") -
              span(v-else class="is-pulled-right") +
          div.columns.is-multiline.is-value(:class="display" v-if="items.item.length && display !== 'spider' " :style="{color: items.colore }")
            indicators-item(v-for="(indicator, index) in items.item" :key="index" :index="index" :item="indicator" :display="display")
          div.spider(v-else)
            v-chart(
              :type="`line`"
              :polar="true"
              :legend="false"
              :series="spiderData(items.item).series"
              :xAxis="spiderData(items.item).label"
            )
</template>

<script>
import IconBase from '@/components/IconBase'
import IconLineChart from '@/components/icons/IconLineChart'
import IconGrid from '@/components/icons/IconGrid'
import IconList from '@/components/icons/IconList'
import IndicatorsItem from '@/components/IndicatorsItem'
import IconAutorizzazione from '@/components/icons/IconAutorizzazione'
import IconConcluso from '@/components/icons/IconCompletamento'
import IconPianificazione from '@/components/icons/IconPianificazione'
import IconConcertazione from '@/components/icons/IconConcertazione'
import IconRealizzazione from '@/components/icons/IconRealizzazione'
import IconGraphs from '@/components/icons/IconGraphs'
import VChart from '@/components/VChart'
// https://github.com/dollarshaveclub/stickybits
import stickybits from 'stickybits'

export default {
  name: 'TheIndicators',
  components: {
    VChart,
    IconBase,
    IconLineChart,
    IconGrid,
    IconList,
    IconGraphs,
    IndicatorsItem,
    IconAutorizzazione,
    IconConcluso,
    IconPianificazione,
    IconRealizzazione,
    IconConcertazione
  },
  props: {
    action: {
      type: Object
    },
    idFase: {
      type: [String, Number]
    },
    configurator: {
      type: Array
    }
  },
  computed: {
    fasi () {
      return this.$store.getters.fasi
    },
    fase () {
      return this.$route.params.fase
    },
    selectedActions () {
      return this.$store.getters.selectedActions(this.action)
    }
  },
  data: function () {
    return {
      display: 'grid',
      selected: null
    }
  },
  mounted: function () {
    stickybits('.is-fix', {noStyles: true})
    this.init()
  },
  methods: {
    init () {
      // code
      this.$store.dispatch('LOAD_CONFIG').then(results => {
        this.$store.dispatch('LOAD_FASI', {id: this.$route.params.id, config: results})
        if (this.action) {
          this.$store.dispatch('LOAD_CONFIG').then(results => {
            this.$store.dispatch('LOAD_INDICATORS_CONFIGURATOR', {idAzione: this.action['Azioni.idAzione'], fase: this.$route.params.fase, config: results})
          })
        }
        this.$store.commit('SET_MAXIMIZE')
      })
    },
    changeDisplay (display) {
      this.display = display
    },
    select (index) {
      this.selected = this.selected === index ? null : index
    },
    setFase (value) {
      if (this.$route.params.fase.toLowerCase() === value.toLowerCase() || !this.fasi[value]) {
        return false
      } else {
        this.$router.push({name: 'indicators', params: {id: this.$route.params.id, fase: value}})
        this.$store.dispatch('LOAD_CONFIG').then(results => {
          this.$store.dispatch('LOAD_INDICATORS_CONFIGURATOR', {idAzione: this.action['Azioni.idAzione'], fase: value, config: results})
        })
      }
    },
    status (fase) {
      if (this.fase === fase) {
        return {value: 'active', color: '#ffffff'}
      } else if (!this.fasi[fase]) {
        return {value: 'not-available', color: '#c2c2c2c2'}
      } else {
        return {value: 'available', color: '#0567b3'}
      }
    },
    spiderData (indicatori) {
      return {
        label: indicatori.map(i => i.idweb),
        series: [
          {
            name: 'valore',
            data: this.groupDataByValue(
              indicatori.map(i => i.indicatore),
              indicatori.map(i => i.valore),
              indicatori.map(i => i.soglia)[0],
              '#77bd8b',
              '#d7716c'
            ),
            pointPlacement: 'on',
            color: '#769cbd'
          },
          {
            name: 'soglia',
            data: indicatori.map(i => i.soglia),
            pointPlacement: 'on',
            dashStyle: 'shortdash',
            marker: { enabled: false },
            color: '#b2b2b2'
          }
        ]
      }
    },
    groupDataByValue (name, data, threshold, aboveColor, belowColor) {
      const newData = []
      data.forEach(value => {
        const dataPoint = {
          y: value,
          name: name,
          marker: {}
        }
        let color
        if (dataPoint.y > threshold) {
          color = aboveColor
        } else {
          color = belowColor
        }
        dataPoint.color = color
        dataPoint.marker.fillColor = color
        newData.push(dataPoint)
      })
      return newData
    }
  }
}
</script>

<style lang="scss" scoped>
.is-fix {
  top: -1em;
  background-color: #ffffff;
  z-index: 2;
}

h2.title {
  padding: 1em 0 1.1em 1.7em;
  background-color: lighten($background, 22%);
  margin-top: -.2em;
  margin-bottom: 0;
  color: $link;
  font-weight: 300;
  svg {
    margin-right: .5em;
    margin-bottom: -6px;
  }
  .meta {
    float: right;
    padding: 0 .5em;
    cursor: pointer;
  }
}
.action-heading {
  margin-bottom: .5rem;
}
.action-text {
  font-size: .9rem;
  padding-bottom: 2rem;
  line-height: 1.3;
}

.text-colored {
  color: $link;
}

.indicator-list {
  list-style: none;
  margin-left: 0;
  ul {
    margin-left: 0;
    margin-bottom: 0em;
    margin-top: 0;
    & > li {
      margin-top: 0;
      margin-bottom: .06em;
      overflow: hidden;
      max-height: 3em;
      transition: max-height 0.15s ease-out;
      &.active {
        max-height: 1000em;
        transition: max-height 0.25s ease-in;
      }
    }
  }
  h6 {
    cursor: pointer;
    height: 3em;
    margin-bottom: 0.6em;
    padding: 1em 1em 1em 2em;
    background-color: silver;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    span {
      color: #ffffff;
    }
    span:not(.name) {
      margin-right: 0.7rem;
      font-size: 1.4rem;
      line-height: 0.7;
    }
  }
}
.is-value {
  position: relative;
  padding: 0.2rem .8rem 0.2rem 1.5rem;
  margin-bottom: .05em;
  &::before {
    z-index: 1;
    position: absolute;
    width: 0;
    height: 0;
    top: 0;
    left: 50%;
    transform: translateX(-86%);
    margin-left: 1.255em;
    vertical-align: 1.255em;
    content: "";
    border-top: 1.3em solid;
    border-right: 1.3em solid transparent;
    border-bottom: 0;
    border-left: 1.3em solid transparent;
  }
}

.fasi {
  height: 122px;
  font-size: .8em;
  text-align: center;
  & div:first-child .fase {
    border-right: 1px solid #e3e3e3;
  }
}
.fase {
  text-align: center;
  height: 100px;
  .title {
    color: $mainBlu;
    font-weight: normal;
  }
  &.active {
    color: $mainBlu;
    .icon-wrapper {
      background-color: $link;
      cursor: inherit;
    }
  }
  &.not-available {
    color: #c4c4c4;
    .icon-wrapper {
      background-color: #f5f5f5;
      border-color: #f5f5f5;
      cursor: not-allowed;
    }
  }
}
.icon-wrapper {
  cursor: pointer;
  display: flex;
  text-align: center;
  align-items: center;
  justify-content: center;
  width: 54px;
  height: 54px;
  margin: 1.5em auto .5em;
  border-radius: 50%;
  border: 1px solid $link;
  svg {
    margin-bottom: 0;
  }
}

.spider {
  & > .container {
    width: 100%;
    max-width: inherit;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/TheIndicators.vue